import { render, staticRenderFns } from "./poolBrandList.vue?vue&type=template&id=d9977fae&scoped=true"
import script from "./poolBrandList.vue?vue&type=script&lang=ts"
export * from "./poolBrandList.vue?vue&type=script&lang=ts"
import style0 from "./poolBrandList.vue?vue&type=style&index=0&id=d9977fae&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9977fae",
  null
  
)

export default component.exports